import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "floating-timer" }
const _hoisted_2 = {
  key: 0,
  class: "theme-selector-overlay"
}
const _hoisted_3 = { class: "theme-selector-modal" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "themes-list" }
const _hoisted_6 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_7 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "theme-name" }
const _hoisted_10 = { class: "project-name" }
const _hoisted_11 = { class: "timer-display" }
const _hoisted_12 = {
  key: 1,
  class: "expanded-view"
}
const _hoisted_13 = { class: "expanded-header" }
const _hoisted_14 = { class: "timer-display-large" }
const _hoisted_15 = { class: "header-actions" }
const _hoisted_16 = {
  key: 0,
  class: "current-theme"
}
const _hoisted_17 = {
  key: 1,
  class: "no-timer-message"
}
const _hoisted_18 = {
  key: 2,
  class: "role-selector"
}
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showThemeSelector)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[11] || (_cache[11] = _createElementVNode("h3", null, "Select a project/task", -1)),
              _createElementVNode("button", {
                class: "close-btn",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCloseThemeSelector && _ctx.handleCloseThemeSelector(...args)))
              }, [
                _createVNode(_component_Icon, { icon: "material-symbols:close" })
              ])
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.themeSearch) = $event)),
              class: "search-input",
              placeholder: "Search projects...",
              autofocus: ""
            }, null, 512), [
              [_vModelText, _ctx.themeSearch]
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.themesLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Loading..."))
                : (_ctx.filteredThemes.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, " No projects found "))
                  : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredThemes, (theme) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: theme.id,
                  class: "theme-item",
                  onClick: ($event: any) => (_ctx.handleSelectThemeWithNotes(theme))
                }, [
                  _createElementVNode("span", {
                    class: "color-dot",
                    style: _normalizeStyle({ backgroundColor: theme.project?.color || '#666' })
                  }, null, 4),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(theme.name), 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(theme.project?.name), 1)
                ], 8, _hoisted_8))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["timer-widget", { expanded: _ctx.isExpanded, running: _ctx.currentTimer?.running }])
    }, [
      (!_ctx.isExpanded)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "collapsed-view",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleExpanded && _ctx.toggleExpanded(...args)))
          }, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formattedTime), 1),
            _createElementVNode("button", {
              class: "play-pause-btn",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleStartTimer && _ctx.handleStartTimer(...args)), ["stop"]))
            }, [
              (!_ctx.currentTimer?.running)
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 0,
                    icon: "material-symbols:play-arrow-rounded"
                  }))
                : (_openBlock(), _createBlock(_component_Icon, {
                    key: 1,
                    icon: "material-symbols:pause-rounded"
                  }))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.formattedTime), 1),
              _createElementVNode("div", _hoisted_15, [
                (_ctx.currentTimer)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "delete-btn",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.deleteTimer && _ctx.deleteTimer(...args))),
                      title: "Delete timer without creating timesheet"
                    }, [
                      _createVNode(_component_Icon, { icon: "material-symbols:delete-rounded" })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "close-expand-btn",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleExpanded && _ctx.toggleExpanded(...args)))
                }, [
                  _createVNode(_component_Icon, { icon: "material-symbols:expand-less" })
                ])
              ])
            ]),
            (_ctx.currentThemeName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.currentThemeName), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, "No active timer")),
            (_ctx.currentTimer && _ctx.availableRoles.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "role-label" }, "Role:", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedRole) = $event)),
                    class: "role-dropdown"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableRoles, (role) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: role.id,
                        value: role
                      }, _toDisplayString(role.name), 9, _hoisted_19))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.selectedRole]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_20, [
              (!_ctx.currentTimer?.running && _ctx.currentTimer)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "action-btn restart",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.restartTimer && _ctx.restartTimer(...args)))
                  }, [
                    _createVNode(_component_Icon, { icon: "material-symbols:play-arrow-rounded" }),
                    _cache[13] || (_cache[13] = _createTextVNode(" Resume ", -1))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.currentTimer?.running)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "action-btn stop",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.stopTimer && _ctx.stopTimer(...args)))
                  }, [
                    _createVNode(_component_Icon, { icon: "material-symbols:stop-rounded" }),
                    _cache[14] || (_cache[14] = _createTextVNode(" Stop ", -1))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.currentTimer && !_ctx.currentTimer.running)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "action-btn timesheet",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleCreateTimesheet && _ctx.handleCreateTimesheet(...args)))
                  }, [
                    _createVNode(_component_Icon, { icon: "material-symbols:receipt-long" }),
                    _cache[15] || (_cache[15] = _createTextVNode(" Create Timesheet ", -1))
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.currentTimer)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    class: "action-btn start",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleStartTimer && _ctx.handleStartTimer(...args)))
                  }, [
                    _createVNode(_component_Icon, { icon: "material-symbols:play-arrow-rounded" }),
                    _cache[16] || (_cache[16] = _createTextVNode(" Start Timer ", -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
    ], 2)
  ]))
}